/* unplugin-vue-components disabled */import script from "./AccountTableBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccountTableBlock.vue?vue&type=script&setup=true&lang=ts"

import "./AccountTableBlock.vue?vue&type=style&index=0&id=7ff8c7d8&scoped=true&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ff8c7d8"]])

export default __exports__